<style></style>

<template>
  <div class="main-wrapper">
    <section class="section main-section bg-gradient-default min-vh-100 pt-3">
      <main class="container card shadow shadow-lg--hover mb-3" id="main">
        <Header title="Revisiones" />
        <div class="text-center" :class="loading ? 'mb-3' : ''">
          <b-spinner variant="light" type="grow" v-show="loading"></b-spinner>
        </div>
        <div v-show="!loading">
          <b-row class="mb-3">
            <b-col cols="6">
              <b-button-toolbar>
                <b-button
                  variant="default"
                  @click.stop="navigateBack()"
                  size="sm"
                >
                  <b-icon-chevron-left scale="1.5" />
                </b-button>
              </b-button-toolbar>
            </b-col>
            <b-col cols="6">
              <b-button-toolbar class="float-right">
                <b-button-group>
                  <b-button
                    variant="success"
                    size="sm"
                    v-if="isAdmin"
                    @click.stop="createRevision()"
                  >
                    <b-icon-plus scale="1.75" />
                  </b-button>
                </b-button-group>
              </b-button-toolbar>
            </b-col>
          </b-row>
          <b-list-group class="mb-3" v-show="!loading">
            <b-list-group-item
              v-for="template in revisions"
              :key="template.revision"
              class="flex-column align-items-start"
            >
              <div class="d-flex justify-content-between">
                <h5 class="mb-1">{{ template.name }}</h5>
                <small>Revision: #{{ template.revision }}</small>
              </div>

              <div>
                <p>
                  Checklist contiene
                  {{ template.questions.length }} preguntas.
                </p>
                <small class="text-muted">
                  Creado hace {{ template.createdOn | timestamp }} y modificado
                  hace {{ template.lastUpdatedAt | timestamp }}
                </small>
              </div>
              <b-button-toolbar class="mt-1">
                <b-button-group class="mx-1 mt-1">
                  <b-button
                    size="sm"
                    variant="info"
                    @click.stop="listEntries(template)"
                  >
                    <span v-if="!lazyLoading"
                      >Ver
                      {{ calculateNumberOfEntries(template) }}
                      entrada(s)</span
                    >
                    <b-spinner v-else small variant="light"></b-spinner>
                  </b-button>
                  <b-button
                    size="sm"
                    variant="primary"
                    @click.stop="fillCheckList(template)"
                  >
                    Crear entrada
                  </b-button>
                </b-button-group>
              </b-button-toolbar>
            </b-list-group-item>
          </b-list-group>
        </div>
      </main>
    </section>
  </div>
</template>

<script>
import moment from "moment";
import { mapActions, mapGetters } from "vuex";
import * as R from "ramda";
import Header from "../Header.vue";

moment.locale("es");

const sortByRevision = R.sortBy(R.prop("revision"));

export default {
  name: "Revisions",
  components: {
    Header,
  },
  async created() {
    const { templateId } = this.$route.params;
    this.loading = true;
    await this.fetchRevisions({ templateId });
    this.loading = false;

    this.revisions = sortByRevision(this.getRevisions(templateId));

    this.loadEntriesFromRevisions();
  },
  data() {
    return {
      loading: false,
      lazyLoading: false,
      revisions: [],
    };
  },
  computed: {
    ...mapGetters("templates", ["getRevisions"]),
    ...mapGetters("checklists", ["getEntries"]),
    ...mapGetters("auth", ["isAdmin"]),
  },
  methods: {
    ...mapActions("templates", ["fetchRevisions"]),
    ...mapActions("checklists", ["fetchCheckListEntriesFromTemplate"]),
    async loadEntriesFromRevisions() {
      this.lazyLoading = true;
      try {
        await Promise.all(
          this.revisions.map((rev) =>
            this.fetchCheckListEntriesFromTemplate({
              templateId: rev.id,
              revision: rev.revision,
            })
          )
        );
      } finally {
        this.lazyLoading = false;
      }
    },
    fillCheckList(template) {
      this.$router.push(
        `/checklists/${template.id}/${template.revision}/entry`
      );
    },
    listEntries(template) {
      this.$router.push(
        `/checklists/${template.id}/${template.revision}/entries`
      );
    },
    calculateNumberOfEntries(revision) {
      const entries = this.getEntries(revision.id, revision.revision);
      return entries ? entries.length : 0;
    },
    navigateBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    },
    createRevision() {
      const { templateId } = this.$route.params;
      this.$router.push(`/templates/${templateId}/revision`);
    },
  },
  filters: {
    timestamp(value) {
      return moment(value).fromNow();
    },
  },
};
</script>
